// extracted by mini-css-extract-plugin
export default {"pageTitle":"medicineInformationMemo_pageTitle__goS3n","cancelBtn":"medicineInformationMemo_cancelBtn__97+bE"};